<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('user_import') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="importdata.valid" lazy-validation>
            <v-textarea
              outline
              :rules="importRules"
              v-model="users"
              :placeholder="$t('user_placeholder')"
              :label="$t('user_label')"
              required
            ></v-textarea>

            <input
              ref="csvUpload"
              type="file"
              accept=".csv"
              label="Csv-Upload"
              @change="onFilePicked"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.native="importCurrentData">{{ $t('import_stuff') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
  {
    "de": {
      "audit_import_title" : "Audit-Fragenlisten Import",
      "import_standard" : "Importieren",
      "description_label" : "Beschreibung",
      "audits_label" : "Audit Metadaten",
      "audits_placeholder" : "JSON [\n { \"name\" : \"Audit Name\", \"standard\" : \"ISO9001\",\n ...\n]\noder CSV:\n\"Audit Name\";\"ISO9001\"",
      "field_required" : "Feld darf nicht leer sein"
    },
    "en": {
    }
  }
</i18n>

<script>
import Papa from "papaparse";

import { mapActions } from "vuex";
import { api } from "@/store/modules/users";

export default {
  props: {
    dialog: {
      default: false
    }
  },
  data() {
    return {
      importRules: [
        v => {
          try {
            let importData = JSON.parse(v);

            this.validateInput(importData);
          } catch (e) {
            if (typeof e === "object") {
              return e.message;
            } else {
              return e;
            }
          }
          return true;
        }
      ],
      importdata: {
        isJson: true,
        valid: false,
        data: null
      }
    };
  },
  computed: {
    users: {
      get() {
        if (this.importdata.data === null) {
          return "";
        } else if (this.importdata.isJson) {
          return JSON.stringify(this.importdata.data, undefined, 2);
        } else {
          return this.auditsToCsv(this.importdata.data);
        }
      },
      set(value) {
        this.importdata.valid = false;

        try {
          this.importdata.data = value;
          this.importdata.isJson = true;
          //this.validateAudits(this.importdata.audit_items);
          this.importdata.valid = true;
        } catch (e) {
          console.log("Das war nicht valide");
        }
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.importUsers]),
    async onFilePicked(event) {
      let file = event.target.files[0];
      const that = this;

      Papa.parse(file, {
        header: true,
        dynamicTyping: false,
        encoding: "iso-8859-1",
        complete: function(results) {
          console.log("Resultat", results);
          that.users = results.data;
        }
        /*transform: function(value, column) {
            //console.log(column, value)
            if (column == "chapters") {
                let res = value.split(',')
                let output = []
                for (let key in res) {
                    output.push(
                        { id: res[key] }
                    )
                }
                return output
            } else {
                return value
            }
            
        }*/
      });
    },
    close() {
      this.$emit("update:dialog", false);
    },
    importCurrentData() {
      if (this.$refs.form.validate()) {
        const input_data = this.importdata.data;

        const payload = {
          data: input_data
        };

        console.log("Before sending", payload);

        this.importUsers(payload)
          .then(success => {
            console.log("ImportData: OK", success);
            this.close();
          })
          .catch(reason => {
            console.log("ImportData: Failed", reason);
          });
      } else {
        console.log("ImportData: Invalid");
      }
    },
    validateInput(importData) {
      console.log("Validate Audit Items", typeof importData);
      if (!(importData instanceof Array)) {
        throw "root must be an array";
      }
      if (importData.length < 1) {
        throw "at least one audititem required";
      }

      for (let row of importData) {
        /*  if (typeof audit.chapters !== 'object') {
            throw "Chapters must be an object";
          }*/
        if (typeof row.displayName !== "string") {
          throw "Chapters must be an string";
        }
      }
    },
    auditsToCsv(audits) {
      let lines = '"id";"description"';
      for (let audit of audits) {
        lines +=
          '\n"' +
          audit.id.replace("\\", "\\\\").replace('"', '\\"') +
          '";"' +
          audit.description.replace("\\", "\\\\").replace('"', '\\"') +
          '"';
        console.log(audit);
      }
      return lines;
    }
  }
};
</script>
